import type { SVGProps } from 'react';

export const PlusIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    {...props}
  >
    <rect
      x="1.27344"
      y="1.02588"
      width="23.8089"
      height="23.8089"
      rx="4.5"
    />
    <rect
      x="12.4155"
      y="7.30762"
      width="2.20538"
      height="11.2452"
      rx="1.10269"      
      fill="currentColor"
    />
    <rect
      x="19.1406"
      y="11.8276"
      width="2.20538"
      height="11.2452"
      rx="1.10269"
      transform="rotate(90 19.1406 11.8276)"      
      fill="currentColor"
    />
  </svg>
);
